// frontend/src/lib/api.js
const BASE = process.env.REACT_APP_API_URL || 'https://agreement.akcoda.in/backend/api';

const token = () => localStorage.getItem('akcoda_token');

async function req(path, opts = {}) {
  const headers = { 'Content-Type': 'application/json', ...(opts.headers || {}) };
  if (token()) headers['Authorization'] = `Bearer ${token()}`;

  const res  = await fetch(`${BASE}${path}`, { ...opts, headers });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Something went wrong');
  return data;
}

export const login            = (email, password) => req('/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) });
export const getAgreements    = (params = {}) => { const q = new URLSearchParams(params).toString(); return req(`/agreements${q ? '?' + q : ''}`); };
export const createAgreement  = (data) => req('/agreements', { method: 'POST', body: JSON.stringify(data) });
export const updateAgreement  = (id, data) => req(`/agreements/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteAgreement  = (id) => req(`/agreements/${id}`, { method: 'DELETE' });
export const resendAgreement  = (id) => req(`/agreements/${id}/resend`, { method: 'POST' });
export const getPublicAgreement = (id) => req(`/agreements/public/${id}`);
export const signAgreement    = (id, signatureName) => req(`/agreements/public/${id}/sign`, { method: 'POST', body: JSON.stringify({ signatureName }) });
